import { render, staticRenderFns } from "./ProjectStatisticsBarChart.vue?vue&type=template&id=3692bc49&scoped=true"
import script from "./ProjectStatisticsBarChart.vue?vue&type=script&lang=js"
export * from "./ProjectStatisticsBarChart.vue?vue&type=script&lang=js"
import style0 from "./ProjectStatisticsBarChart.vue?vue&type=style&index=0&id=3692bc49&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3692bc49",
  null
  
)

export default component.exports